// Default API base for the widget: the origin the captcha bundle was served from.
//
// A page that embeds `<script src="https://captcha.qr6.eu/captcha.min.js">` and
// omits `data-api` should talk to that same host. We derive it from the script's
// own URL — the bundle is a classic IIFE script, so `document.currentScript`
// points at our <script> while it executes. No domain is hardcoded, so this works
// for any deployment (incl. a future white-label build) without code changes.
function resolveScriptOrigin() {
  if (typeof document === "undefined") return null;
  try {
    const src = document.currentScript && document.currentScript.src;
    if (src) return new URL(src).origin;
    // currentScript may be null at module-eval time (e.g. async load): fall back
    // to the last <script> whose src looks like our bundle.
    const scripts = document.querySelectorAll("script[src]");
    for (let i = scripts.length - 1; i >= 0; i--) {
      if (/\/captcha(\.min)?\.js(\?|#|$)/.test(scripts[i].src)) {
        return new URL(scripts[i].src).origin;
      }
    }
  } catch {
    /* malformed URL or no DOM — fall through */
  }
  return null;
}

// Captured ONCE at module load: `document.currentScript` is only valid during the
// bundle's initial synchronous execution, not later (idle miner, programmatic API).
export const SCRIPT_ORIGIN = resolveScriptOrigin();

// Endpoint the client defaults to when no explicit `api` is given. Prefer the
// bundle's origin; as a last resort use the embedding page's origin (covers
// same-origin self-hosting where the captcha lives on the page's own domain).
export function defaultApiBase() {
  if (SCRIPT_ORIGIN) return SCRIPT_ORIGIN;
  if (typeof location !== "undefined" && location.origin) return location.origin;
  return "";
}
